import { Role } from '@wavingroup/iot-core/gen/ts/wavin/ignite/v1/user_pb';
import { GlobalPermissionType } from '@wavingroup/iot-core/gen/ts/wavin/kleos/v1/global_permission_pb';

export const KLEOS_ASSIGNABLE_PERMISSIONS = [
  GlobalPermissionType.USER_MANAGEMENT,
  GlobalPermissionType.FIRMWARE_ADMIN,
  GlobalPermissionType.FIRMWARE_EDITOR,
  GlobalPermissionType.FIRMWARE_VIEWER,
  GlobalPermissionType.WAVIN_ADMIN,
  GlobalPermissionType.WAVIN_ONLY,
  GlobalPermissionType.IP_ACCESS,
] as const;

export type KleosAssignablePermission =
  (typeof KLEOS_ASSIGNABLE_PERMISSIONS)[number];

const igniteRoleToKleosPermission: Partial<
  Record<Role, KleosAssignablePermission>
> = {
  [Role.IAM_ADMIN]: GlobalPermissionType.USER_MANAGEMENT,
  [Role.FIRMWARE_ADMIN]: GlobalPermissionType.FIRMWARE_ADMIN,
  [Role.FIRMWARE_EDITOR]: GlobalPermissionType.FIRMWARE_EDITOR,
  [Role.FIRMWARE_VIEWER]: GlobalPermissionType.FIRMWARE_VIEWER,
  [Role.DEVICE_ADMIN]: GlobalPermissionType.WAVIN_ADMIN,
  [Role.CONFIG_EDITOR]: GlobalPermissionType.WAVIN_ONLY,
};

export function toKleosPermission(
  role: Role,
): KleosAssignablePermission | undefined {
  return igniteRoleToKleosPermission[role];
}

export function isAssignableKleosPermission(
  permission: GlobalPermissionType,
): permission is KleosAssignablePermission {
  return (
    KLEOS_ASSIGNABLE_PERMISSIONS as readonly GlobalPermissionType[]
  ).includes(permission);
}
